/**
 * Generates a fresh key for one canonical create-vendor request. Modern
 * browsers provide `randomUUID`; the fallback keeps older runtimes usable
 * without importing an ESM-only dependency into Jest's CommonJS graph.
 */
export function createVendorIdempotencyKey(): string {
  if (
    typeof globalThis.crypto !== 'undefined' &&
    typeof globalThis.crypto.randomUUID === 'function'
  ) {
    return globalThis.crypto.randomUUID()
  }

  return `vendor-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2)}`
}
